export default __webpack_public_path__ + "static/media/bath.8cd9d52d.svg";